import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        submitting: false,
        formData: {
            invoiceNumber: '',
            installationDate: '',
            goingLiveDate: '',
            additionalNotes: '',
            power: false,
            internet: false,
            hardware: false,
            //stockList: false,
            //employeeList: '',
            stockList: '',
            employeeList: '',
            signature: '',
        }
    },
    getters: {
        getFormData: state => state.formData,
        isSubmitting: state => state.submitting,
    },
    mutations: {
        setFormData(state, payload) {
            state.formData = { ...state.formData, ...payload };
        },
        setSubmitting(state, status) {
            state.submitting = status;
        }
    },
    actions: {
        setFormData({ commit }, payload) {
            commit('setFormData', payload);
        },
        async submitFormData({ commit, state }) {
            commit('setSubmitting', true);

            try {
                const response = await axios.post(
                    synergyApi+'jobcards/confirm-job-card-header',
                    state.formData
                );

                console.log('Response:', response); // Log the entire response

                if (response.status >= 200 && response.status < 300) {
                    console.log('Form submitted successfully:', response.data);
                    return true; // Indicate success
                } else {
                    throw new Error(response.data.message || 'Submission failed');
                }
            } catch (error) {
                console.error('Error submitting form:', error);
                let errorMessage = 'Please try again.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
                return errorHandler.tomcatError(error);
                throw new Error(errorMessage);
            } finally {
                commit('setSubmitting', false);
            }
        },
    }
});
